if (!customElements.get('site-sub-drawer')) {
  customElements.define(
    'site-sub-drawer',
    class SiteSubDrawer extends window.BAO.CustomElement {
      CLASSES = {
        activeSubDrawerClass: 'drw-SubDrawer-active',
      }

      constructor () {
        super()

        this.drawers = this.closest('site-drawers')
        if (!this.drawers)
          throw new Error(
            `${this.nodeName.toLowerCase()} should be inside a <site-drawers> element`
          )

        this._isOpen = false
      }

      get key () {
        return this.getAttribute('key')
      }

      get elements () {
        return {
          trigger: window.BAO.utils.getElement(
            `[data-subdrawers-open=${this.key}]`
          ),
          close: window.BAO.utils.getElement(`[data-drawers-close=${this.key}]`),
        }
      }

      get isOpen () {
        return this._isOpen
      }

      set isOpen (val) {
        this._isOpen = val

        this.classList.toggle(this.CLASSES.activeSubDrawerClass, val)
      }
    }
  )
}
